/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { TemporaryOrgUnit as TemporaryOrgUnitData } from "../businessContexts/OrganizationUnit/Lists/types";
import { UserShorthand } from "./AccountsList";

type State = {
  isModalConfirmOpen: boolean;
  initialValues: UserShorthand;
  tempOrgUnitData: TemporaryOrgUnitData;
};

export const initialState = {
  isModalConfirmOpen: false,
  initialValues: {
    id: "",
    name: "",
  },
  tempOrgUnitData: {},
};

type Action =
  | {
      type: ACTION.CLOSE_MODAL;
    }
  | {
      type: ACTION.REMOVE;
      payload: {
        id: string;
        name: string;
      };
    };

export enum ACTION {
  REMOVE = "REMOVE",
  CLOSE_MODAL = "CLOSE_MODAL",
}

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ACTION.REMOVE:
      return {
        ...state,
        isModalConfirmOpen: true,
        tempOrgUnitData: {
          nid: action.payload.id,
          name: action.payload.name,
        },
      };

    case ACTION.CLOSE_MODAL:
      return {
        ...state,
        isModalConfirmOpen: false,
      };

    default:
      throw new Error(`Unknown action: ${action}`);
  }
};
